'use client';

import { useEffect, useRef } from 'react';

export default function AdCard() {
    const adRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        (window as any).AutoAds?.rescan?.();
    }, []);

    return (
        <div className="group flex flex-col bg-surface-elevated border border-border-subtle rounded-2xl overflow-hidden hover:border-brand transition-all duration-300 hover:shadow-2xl hover:shadow-brand/10 h-full">
            <div className="aspect-[16/10] overflow-hidden bg-surface-inset relative">
                {/* Ad Label */}
                <div className="absolute top-3 right-3 z-10 text-[10px] uppercase font-bold text-text-inverse bg-black/50 backdrop-blur-md border border-white/20 px-2 py-0.5 rounded-full">
                    Sponsored
                </div>

                {/* Ad Container and Script Injection Point */}
                <div
                    ref={adRef}
                    className="w-full h-full flex items-center justify-center [&_iframe]:!w-full [&_iframe]:!h-full [&_img]:!w-full [&_img]:!h-full [&_img]:!object-cover"
                >
                    <div data-ad-placement="cmkva3c7500df229zxg5w97g9" className="w-full h-full" suppressHydrationWarning={true}></div>
                </div>
            </div>

            <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-wider text-text-secondary mb-3">
                    <span>Advertisement</span>
                </div>

                <h3 className="text-xl font-bold mb-3 line-clamp-2 text-text-secondary">
                    Promoted Content from our Partners
                </h3>

                <div className="text-text-secondary text-sm line-clamp-3 mb-6 flex-grow">
                    This content is provided by our advertisers and helps us keep our service free for everyone.
                </div>

                <div className="flex items-center gap-2 text-sm font-semibold text-[var(--color-text-main)] mt-auto pt-4 border-t border-border-subtle">
                    <div className="w-8 h-8 rounded-full bg-[var(--color-primary)] flex items-center justify-center text-white font-bold text-xs uppercase">
                        A
                    </div>
                    <span>Ad Partner</span>
                </div>
            </div>
        </div>
    );
}
